export default {
    state: {
        img: ''
    },
    mutations: {
        SET_IMG(state, payload) {
            state.img = payload.value
        }
    },
    actions: {
        setImg(context, value) {
            context.commit('SET_IMG', value)
        }
    },
    getters: {
        getImg(state) {
            return state.img
        }
    }
}